import { GetSchedulesByExperienceIdResponseBodyType } from "@intelligems/ig-types";
import { useQuery } from "@tanstack/react-query";

import { api } from "../api";
import { scheduleKeys } from "../queryKeys";

const getTestSchedules = async (experienceId: string) => {
  const resp = await api.get<GetSchedulesByExperienceIdResponseBodyType>(
    `/v2/schedules/experiences/${experienceId}`
  );
  return resp.data;
};

export const useGetTestSchedules = (experienceId: string) => {
  return useQuery<GetSchedulesByExperienceIdResponseBodyType, Error>({
    queryKey: scheduleKeys.one(experienceId),
    queryFn: async () => getTestSchedules(experienceId),
    enabled: !!experienceId,
  });
};
